<div class="common-layout {{ 'is-' + selectedHeaderColor }}"
    [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }"
>
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
           
            </div>
            <router-outlet></router-outlet>
            <router-outlet name="popup"></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>
